module.exports = __webpack_public_path__ + "static/img/11.6fc7683.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/3/1/sp/11.png
// module id = kE5O
// module chunks = 0